var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<form ng-submit=\"$ctrl.submit()\" name=\"form\"><modal modal-title=\"{{::$ctrl.title}}\" hide-close-button=\"false\" on-dismiss=\"$ctrl.$dismiss()\" instance=\"$ctrl.modal\"><modal-body><div ng-include=\"$ctrl.fieldsetTemplateUrl\"></div></modal-body><modal-footer><div ng-include=\"$ctrl.actionsTemplateUrl\"></div></modal-footer></modal></form>";
var id1="register-current-acct-prompt.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;